import React, { useEffect, useRef, useState } from 'react';

import { Chart3D, Category3D, ColumnSeries3D, Legend3D, Tooltip3D, Highlight3D } from '@syncfusion/ej2-charts';

Chart3D.Inject(ColumnSeries3D, Category3D, Legend3D, Tooltip3D, Highlight3D);

const Chart3DWrapper = ({ id, dataSource, title = '' }) => {
    const chartRef = useRef(null);
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        if (!Array.isArray(dataSource)) {
            setChartData([]);
            return;
        }

        const cleanData = dataSource.filter(item =>
            item &&
            typeof item.x === 'string' &&
            item.x.trim() !== '' &&
            typeof item.y === 'number' &&
            !isNaN(item.y)
        );

        setChartData(cleanData);
    }, [dataSource]);

    useEffect(() => {
        if (!chartData.length || !chartRef.current) return;

        let chart;
        try {
            const maxY = Math.max(...chartData.map(d => d.y));

            chart = new Chart3D({
                primaryXAxis: {
                    valueType: 'Category',
                    labelRotation: -45,
                    labelPlacement: 'BetweenTicks',
                    labelIntersectAction: 'Trim',
                    enableTooltip: false // <- désactive le tooltip sur l'axe X
                },
                primaryYAxis: {
                    maximum: maxY + 10,
                    interval: Math.max(1, Math.floor(maxY / 5))
                },
                series: [
                    {
                        type: 'Column',
                        xName: 'x',
                        yName: 'y',
                        columnSpacing: 0.1,
                        dataSource: chartData
                    }
                ],
                wallColor: 'transparent',
                enableRotation: true,
                rotation: 7,
                tilt: 10,
                depth: 100,
                height: '100%',
                width: '100%',
                title: title,
                tooltip: {
                    enable: true,
                    header: "${point.x}",
                    format: "Expertises : <b>${point.y}</b>"
                },
                legendSettings: {
                    enableHighlight: true,
                    visible: false
                },
                axisLabelRender: (args) => {
                    if (!args || !args.axis || args.axis.name !== 'primaryXAxis' || !args.text) return;

                    const maxLabelLength = 15;
                    args.originalText = args.text;

                    if (args.text.length > maxLabelLength) {
                        const truncated = args.text.substring(0, maxLabelLength) + '...';
                        args.text = truncated;
                    }
                },
                load: (args) => {
                    args.chart.theme = 'Material';
                }
            });

            chart.appendTo(chartRef.current);
        } catch (err) {
            console.error("Erreur lors du rendu Chart3D:", err);
        }

        return () => {
            if (chart) chart.destroy();
        };
    }, [chartData, title]);

    return (
        <div className="w-full h-96 chart-container">
            {chartData.length > 0 ? (
                <div ref={chartRef} id={id}></div>
            ) : (
                <p className="text-gray-500 text-center">Chargement des données</p>
            )}
        </div>
    );
};

export default Chart3DWrapper;
